// extracted by mini-css-extract-plugin
export default {"container":"styles_container__y0oX0","title":"styles_title__8gqWu","content":"styles_content__4tPrQ"};